export default "__VITE_ASSET__Bo8_W6ys__"